// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__FYUkj","productName":"Table_productName__2jn5S"};